$(function () {
    const providerURL = $.p("articlesProvider", "knowledge");

    // Define variables
    let pageNumber = $.p("pageNumber", "knowledge");
    let categorySlug = $.p("categorySlug", "knowledge");
    let initialRequest = true;
    let moreAvailable = false;

    // Load data & change status of the initialRequest variable
    getData();
    initialRequest = false;

    // Bind category filter button
    $("[data-category-slug]").bind("click", function () {
        $("[data-category-slug]").removeClass("active");
        $(this).addClass("active");

        // Reset global variables
        pageNumber = 1;
        initialRequest = true;
        categorySlug = $(this).data("categorySlug");

        // Clear container & get data
        $("#dynamicArticlesContainer").html("");
        getData();

        // Set init request variable
        initialRequest = false;
    });

    // Bind load more button
    $("#loadMore > button").bind("click", function () {
        if (moreAvailable) {
            pageNumber++;
            getData();
        }
    });

    function getData() {
        $.ajax({
            method: "POST",
            url: providerURL,
            data: {
                "pageNumber": pageNumber,
                "categorySlug": categorySlug,
                "initialRequest": initialRequest
            },
            dataType: "json",
            timeout: 30000,
            success: function (responseData) {
                let pageURL = responseData["pageURL"];

                // Overwrite variables
                pageNumber = responseData["pageNumber"];
                moreAvailable = responseData["moreAvailable"];

                // Get provided articles collection
                const articles = responseData["articles"];

                if (Array.isArray(articles)) {
                    articles.forEach(function (article) {
                        $("#dynamicArticlesContainer").append(article["renderHTML"]);
                    });
                }

                // Push window history
                if (window.history.pushState) {
                    window.history.pushState({}, "", pageURL);
                }

                // Show / hide button
                if (moreAvailable) {
                    $("#loadMore").removeClass("d-none");
                } else {
                    $("#loadMore").addClass("d-none");
                }
            }
        });
    }
});

//# sourceMappingURL=knowledge.js.map
